import { Text } from '@rsos/components/capstone/base';
import { InProgressContainer, InProgressDot } from './AudioPlayer.styles';

interface AudioMessageProps {
  message: string;
}
/**
 * Displays a message for the Audio player.
 */
function AudioMessage({ message }: AudioMessageProps) {
  return (
    <InProgressContainer horizontal>
      <InProgressDot />
      <Text size="normal" ml="8px">
        {message}
      </Text>
    </InProgressContainer>
  );
}

export const AudioInProgress = () => (
  <AudioMessage message="Call is in progress. Audio will be available when the call ends." />
);

export const AudioError = () => (
  <AudioMessage message="Audio is unavailable for this call." />
);
